module.exports = __webpack_public_path__ + "static/media/profile-pic-80.f7889bb1.png";